import Constants from 'expo-constants';
import React from 'react';
import { StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as AppConst from '../../components/AppConst';
import ChatList from './ChatList';
import ChatMain from './ChatMain';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  チャット画面ナビゲーション
*  ================================*/
const ChatNavigator = () => {
  return (
    <NavigationContainer>
      <MainStack.Navigator screenOptions={{
        title: Constants.manifest?.name,
        headerStyle: styles.headerStyle,
        headerTintColor: 'white',
        headerTitleAlign: 'center',
        headerBackTitleVisible: false,
      }}>
        <MainStack.Screen name='ChatList' component={ChatList} options={{ headerShown: false }} />
        <MainStack.Screen name='ChatMain' component={ChatMain} />
      </MainStack.Navigator>
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  headerStyle: {
    backgroundColor: AppConst.chatColor,
    height: 40,
  },
});

export default ChatNavigator;
